import CryptoJS from 'crypto-js';

/**
 * 防重放攻击工具类
 * 使用HMAC-MD5 + nonce(随机数) + timestamp(时间戳)机制
 */

// 密钥配置（实际使用时应该从配置文件读取，并定期更换）
const SECRET_KEY = 'dCQsssMYGy'; // 这个密钥需要与后端保持一致

/**
 * 生成随机nonce
 * @param {number} length - nonce的长度，默认32位
 * @returns {string} 随机字符串
 */
export function generateNonce(length = 32) {
  const chars = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';
  let nonce = '';
  for (let i = 0; i < length; i++) {
    nonce += chars.charAt(Math.floor(Math.random() * chars.length));
  }
  return nonce;
}

/**
 * 获取当前时间戳（秒级）
 * @returns {number} 当前时间戳
 */
export function getTimestamp() {
  return Math.floor(Date.now() / 1000);
}

/**
 * 生成HMAC-MD5签名
 * @param {object} params - 请求参数对象
 * @param {string} nonce - 随机数
 * @param {number} timestamp - 时间戳
 * @returns {string} HMAC-MD5签名
 */
export function generateSignature(params, nonce, timestamp) {
  // 1. 将参数按key排序
  const sortedKeys = Object.keys(params).sort();

  // 2. 拼接参数字符串（格式：key1=value1&key2=value2）
  let paramStr = '';
  sortedKeys.forEach(key => {
    if (params[key] !== null && params[key] !== undefined && params[key] !== '') {
      paramStr += `${key}=${params[key]}&`;
    }
  });

  // 3. 添加nonce和timestamp
  paramStr += `nonce=${nonce}&timestamp=${timestamp}`;

  // 4. 使用HMAC-MD5生成签名
  const signature = CryptoJS.HmacMD5(paramStr, SECRET_KEY).toString();

  return signature;
}

/**
 * 为请求添加防重放攻击参数
 * @param {object} params - 原始请求参数
 * @returns {object} 添加了签名、nonce和timestamp的参数对象
 */
export function addAntiReplayParams(params) {
  // 生成nonce和timestamp
  const nonce = generateNonce();
  const timestamp = getTimestamp();

  // 生成签名（只对业务参数签名，不包含签名字段本身）
  const signature = generateSignature(params, nonce, timestamp);

  // 返回包含防重放参数的对象
  return {
    ...params,
    nonce,
    timestamp,
    signature
  };
}

/**
 * 验证签名是否有效（可选，用于本地调试）
 * @param {object} params - 包含签名的参数对象
 * @returns {boolean} 签名是否有效
 */
export function verifySignature(params) {
  const { nonce, timestamp, signature, ...businessParams } = params;

  if (!nonce || !timestamp || !signature) {
    return false;
  }

  // 重新生成签名进行比对
  const expectedSignature = generateSignature(businessParams, nonce, timestamp);

  return signature === expectedSignature;
}


